/* eslint-disable max-len */

export const es = {
  translation: {
    'app-subscription-4-7d-trial-per-day': {
      upsells: {
        header: {
          step1: 'Comprar informe',
          step2: 'Consultas',
          step3: 'Acceso al producto',
          banner: {
            title: '¡Gracias!',
            text: '¡Tu pedido fue exitoso!',
          },
          title: 'Elige tu oferta de registro',
          subtitle: 'Disponible solo ahora',
        },
        headerNew: {
          addReport: 'Añadir informe',
          unlimitedReadings: 'Lecturas ilimitadas',
          addConsultation: 'Añadir consulta',
          accessProduct: 'Acceso al producto',
        },
        footer: {
          description:
            '*Se le cobrará por los servicios o productos adicionales seleccionados en el momento de la compra.' +
            'Este no es un pago recurrente.',
        },
        button: 'Obtener mi copia',
        link: 'Omitir esta oferta y continuar',
      },
      trialCredits: {
        header: {
          step1: 'Comprar informe',
          step2: 'Consultas',
          step3: 'Acceso al producto',
          title: 'Más para ti',
          subtitle: 'Oferta exclusiva recomendada para que alcances tus objetivos más rápido',
        },
        payment: {
          title: 'Tu consulta individual única',
          consultation:
            '<highlight>De 30 minutos privada </highlight><br />' +
            '<highlight>consulta con un experto</highlight>',
          description:
            'Puede solicitar una predicción del futuro, un análisis de compatibilidad en vivo; compatibilidad' +
            ' amorosa, etc.',
          offerPrice: 'Oferta de precio única:',
          originalPrice: {
            price: 'Precio original:',
            discount: 'Ahorrar',
          },
        },
        footer: {
          description:
            '*Se le cobrará por los servicios o productos adicionales seleccionados en el momento de la compra.' +
            '<br /> Esto es un pago no recurrente.',
        },
        button: 'Obtener mi consulta',
        link: 'Omitir esta oferta y continuar',
      },
      unlimitedReadings: {
        title: 'Accede a las guías astrológicas y lecturas de compatibilidad ilimitadas',
        contains: {
          affirmations: 'afirmaciones personales para cada día',
          moreInsights: 'más información en menos tiempo',
          learnVisually: 'aprender visualmente',
          minutesToRead: 'minutos para leer',
        },
        benefits: {
          unlimitedCompatibilityChecks: 'comprueba la compatibilidad tantas veces como necesites',
          manyInsight:
            'cientos de ideas que le ayudarán a alcanzar sus objetivos en las relaciones de pareja',
          dailyHoroscopes: 'horóscopos diarios personalizados y guías astrológicas sin anuncios',
          autoRenewable: 'plan autorenovable de 1 mes, cancelación en cualquier momento',
        },
        button: 'Añadir lecturas ilimitadas',
        skip: 'Omita esta oferta y siga adelante',
        disclaimer:
          'Nota: Además de su suscripción, se cargará en su cuenta {{price}} por los complementos seleccionados al hacer clic en Añadir lecturas ilimitadas. Los artículos de esta página son suscripciones de {{period}}. A menos que la canceles en tu perfil antes de que finalice el periodo en curso, aceptas que la suscripción se renueve automáticamente al final de cada periodo. Si necesita ayuda sobre cómo cancelarla, visite nuestra página ',
      },
      trialPaymentWithDiscount: {
        offer: 'Descuento SECRETO <bold>de 65%</bold> aplicado',
        title: '¡Obtienes un descuento secreto!',
        pay: 'Comienza tu prueba de 7 días',
        subtitle: 'Sin presión. Cancela cuando quieras.',
        specialCode: '¡Descuento secreto aplicado!',
        price: 'Tu costo por 2 semanas después de la prueba:',
        priceExperiment: 'Tu costo por 30 días después de la prueba:',
        saveMoney: 'Te ahorras {{savedMoney}} cada periodo',
        saveMoneyExperiment: 'Te ahorras {{savedMoney}}',
        total: 'Total hoy:',
        description: `Al continuar, aceptas que si no cancelas antes de que finalicen los 7 días de prueba, se te cobrará automáticamente {{ discountPrice }} durante el periodo introductorio 2 semanas días y, a partir de entonces, la tarifa estándar de {{ fullPrice }} cada 2 semanas hasta que canceles en ajustes. Más información sobre la política de cancelación y reembolso en`,
        descriptionExperiment: `Al continuar, aceptas que si no cancelas antes de que finalicen los 7 días de prueba, se te cobrará automáticamente {{ discountPrice }} durante el periodo introductorio de 30 días y, a partir de entonces, la tarifa estándar de {{ fullPrice }} cada 30 días hasta que canceles en ajustes. Más información sobre la política de cancelación y reembolso en`,
        terms: 'Términos de suscripción',
      },
      salesScreen: {
        title: 'Su Claridad Personalizada & ¡Lectura del Amor está lista!',
        fixedHeader: {
          title: `Descuento expirado`,
          minutes: 'min',
          seconds: 'sec',
          button: 'obtener mi lectura',
        },
        userDetails: {
          youImageText: 'Usted',
          partnerImageText: 'Socio',
          zodiac: 'Signo del zodiaco',
          gender: 'Género',
          dateOfBirth: 'Fecha de nacimiento',
          placeOfBirth: 'Lugar de nacimiento',
          female: 'Mujer',
          male: 'Hombre',
        },
        sectionGoal: {
          title: 'El objetivo a alcanzar',
          'Find my perfect partner': 'Encontrar mi pareja perfecta',
          'Understand myself better': 'Conocerme mejor a mi mismo/a',
          'To get married': 'Para casarse',
          'Achieve happiness': 'Alcanzar la felicidad',
          'Personal growth': 'Crecimiento personal',
          'Check compatibility': 'Compruebe la compatibilidad',
          'Increase relationship satisfaction': 'Estar más satisfecho con mi relación',
          'Fix relationship problems': 'Solucionar problemas de relación',
          'Build a strong marriage': 'Construir un matrimonio sólido',
          'All above': 'Encontrar el amor y comprenderme mejor',
          'All above in relationships': 'Mejorar la relación',
        },
        specialOffer: {
          header: 'Oferta especial',
          trialTitle: 'Lectura personalizada para ',
          total: 'Total hoy:',
          discount: 'Descuento expirado',
          saveMoney: 'Ahorre {{discount}} cada periodo',
          perWeeksCostOld: 'Coste post-prueba de 30 días',
          perWeeksCost: 'Incluye 1 semana de prueba de lectura personal',
          optionTitle: 'Elige la opción:',
          expensiveOption:
            'Apoyar a quienes necesitan elegir el precio de prueba más bajo eligiendo esta opción!',
          getAccess: 'obtener mi lectura',
        },
        guaranteeText: 'Garantías de pago',
        blurredReport: {
          title: 'Su informe',
          zodiac: 'Signo del zodiaco',
          gender: 'Género',
          contentTitle: 'Contenido',
          points: [
            'Compatibilidad con su pareja en otras áreas de su vida.',
            'Análisis profundo de las relaciones con su pareja basado en ' +
              'un sistema único de correspondencia de cartas natales.',
            'Guía sencilla y práctica para mejorar la relación con su pareja',
            'Advertencia sobre acontecimientos astrológicos y consejos prácticos ' +
              'que te ayudarán a superar bien este periodo',
            'Tu horóscopo y los próximos acontecimientos para 2023',
            'Tus puntos fuertes y débiles exclusivos y cómo sacarles el máximo partido',
          ],
          personalityTitle: 'Personalidad',
          personalityContent:
            'Acuario es el undécimo signo del zodíaco y representa la inventiva y la brillantez. ' +
            'Sus planetas regentes son Urano y Saturno, lo que confiere a este signo una mezcla única de ' +
            'personalidad restringida pero liberada. Saturno se asocia con los límites y las fronteras, ' +
            'mientras que Urano es',
          accessDescription: 'Para leer el informe completo necesita obtener aceess',
          getAccess: 'obtener mi lectura',
        },
        userReviews: {
          title: 'Los usuarios nos adoran',
          list: {
            user1: {
              review:
                'Fue realmente útil y me proporcionó la claridad que necesitaba para mi ' +
                'situación sentimental actual. Me da esperanzas de que mi relación aún pueda ' +
                'salvarse. Muchas gracias. Muy recomendable.',
            },
            user2: {
              review:
                'Increíble, ¡absolutamente increíble! Las afirmaciones que recibí y los consejos nutritivos ' +
                'valieron la pena. De verdad, ¡gracias!',
            },
            user3: {
              review:
                'Me ayuda a confiar en mí misma y en mis decisiones para el futuro dándome ' +
                'seguridad con la información que recibo. Mis metas y sueños se van a cumplir y ' +
                'ahora confío en mí misma para hacer lo que necesito y deseo.',
            },
          },
        },
        benefits: {
          title: 'Lo que obtienes',
          points: [
            'Su plan personalizado',
            'Asesoramiento 1:1 de su propio astrólogo',
            'Encontrar la pareja más compatible',
            'IComprensión de sus patrones de relación y de sus necesidades emocionales y sexuales.',
            'Mejor comprensión de uno mismo',
          ],
        },
        featuredInTitle: 'Como aparece en',
        QASection: {
          title: 'La gente suele preguntar',
          question1: '¿Cuál es la precisión de la lectura astrológica en esta plataforma?',
          answer1:
            'La exactitud en astrología, siendo subjetiva, puede brindar insights valiosos. ' +
            'Nuestra plataforma, con algoritmos avanzados y expertos, busca maximizar esta precisión.',
          question2: '¿Puedo obtener una lectura de compatibilidad de relaciones?',
          answer2:
            'Sí, se puede obtener una lectura de compatibilidad para las relaciones. Este tipo de lectura ' +
            'incluye un análisis astrológico exhaustivo de dos personas para evaluar su compatibilidad en ' +
            'diversas áreas, como el amor, la comunicación y los valores compartidos.',
          question3: '¿Son confidenciales y privadas las lecturas astrológicas de esta plataforma?',
          answer3:
            'Sí, todas las lecturas de nuestra plataforma son estrictamente confidenciales. Respetamos la ' +
            'privacidad de nuestros usuarios y garantizamos que todos los datos personales y lecturas se ' +
            'almacenan de forma segura y no se comparten con terceros sin consentimiento.',
        },
        charge: {
          trial:
            'Sólo se le cobrará <bold>{{trialPrice}}  por sus 7 días de prueba.</bold><br/>' +
            'Te enviaremos un <bold>recordatorio por correo electrónico</bold> antes de que finalice el ' +
            'periodo de prueba. <bold>Cancele en cualquier momento.</bold>',
          europeanTrial:
            'Sólo se le cobrará <bold>{{europeanTrialPrice}}  por sus 7 días de prueba.</bold><br/>' +
            'Te enviaremos un <bold>recordatorio por correo electrónico</bold> antes de que finalice el ' +
            'periodo de prueba. <bold>Cancele en cualquier momento.</bold>',
          trialUSStart: 'Está suscribiéndose durante 2 semanas al servicio ',
          trialUSEnd:
            '. Al continuar acepta que si no cancela antes del final de la prueba de 7 días por el {{trialPrice}} se' +
            ' le cobrará automáticamente {{fullPrice}} cada 2 semanas hasta que cancele en la configuración. El' +
            ' cargo aparecerá en tu factura como {{domainUrl}}. Más información sobre la política de cancelación y' +
            ' reembolso en',
          trialUS:
            'Usted se inscribe en la suscripción mensual al servicio NEBULA. Al continuar acepta que si no cancela antes del final de la prueba de 7 días para el {{trialPrice}} se le cobrará automáticamente {{fullPrice}} cada 30 días hasta que cancele en la configuración. El cargo aparecerá en tu factura como {{domainUrl}}. Más información sobre la política de cancelación y reembolso en ',
        },
        chargeTest:
          'Sólo se le cobrará <bold>{{price}} por sus 7 días de prueba.</bold><br/>' +
          'Te enviaremos un <bold>recordatorio por correo electrónico</bold> antes de que finalice el ' +
          'periodo de prueba. <bold>Cancele en cualquier momento.</bold>',
        description: {
          text:
            'Está contratando una suscripción de 2 semanas al NEBULA servicio. ' +
            'Al continuar aceptas que si no cancelas antes del final de los 7 días de prueba por ' +
            'el importe de <bold>{{trialPrice}}</bold> ' +
            'se te cobrarán automáticamente <bold>{{plan}}</bold> ' +
            'cada 2 semanas hasta que canceles en ajustes. Más información sobre ' +
            'la política de cancelación y reembolso en ',
          textEU:
            'Está contratando una suscripción de 2 semanas al NEBULA servicio. ' +
            'Al continuar aceptas que si no cancelas antes del final de los 7 días de prueba por ' +
            'el importe de <bold>{{europeanTrialPrice}}</bold> ' +
            'se te cobrarán automáticamente <bold>{{plan}}</bold> ' +
            'cada 2 semanas hasta que canceles en ajustes. Más información sobre ' +
            'la política de cancelación y reembolso en ',
          terms: 'Política de suscripción',
          termsEU: 'Política de suscripción',
          termsExperiment: 'Condiciones de suscripción',
        },
        trialChoiceDescription: {
          header:
            'Hemos ayudado a millones de personas a tener vidas más felices y mejores relaciones, y ' +
            'queremos ayudarte a ti también.',
          money:
            'El dinero no debería interponerse en el camino de encontrar una guía astrológica que ' +
            'finalmente funcione. Así que, elige una cantidad que creas razonable para probarnos por una semana.',
          paymentDescription:
            'Nos cuesta {{priceForUs}} para ofrecer una prueba de 7 días, pero elige la cantidad' +
            ' con la que te sientas cómodo/a.',
        },
      },
      payment: {
        title: 'Elige el método de pago',
        divider: 'o',
        chargeDisclaimer: 'Se le cobrará únicamente',
        form: {
          default: {
            submitButtonText: 'Inicia la Prueba de 7 Días',
            charged: 'Solo se te cobrará ',
            trial: ' por tu prueba de 7 días.',
          },
          resign: {
            submitButtonText: 'Comprar',
          },
        },
        charge: {
          trialWithoutPrice:
            'Te <bold>enviaremos un recordatorio por email</bold> antes de que termine tu período de prueba. ' +
            'Cancela en cualquier momento.',
          trial:
            'Solo se te cobrará <bold>{{price}} por tu prueba de 7 días.</bold><br/>' +
            'Te <bold>enviaremos un recordatorio por email</bold> antes de que termine tu período de prueba. ' +
            'Cancela en cualquier momento.',
          trialUS:
            'Solo se te cobrará <bold>{{price}} por tu prueba de 7 días.</bold><br/>' +
            'Te <bold>enviaremos un recordatorio por email</bold> antes de que termine tu período de prueba. ' +
            'Cancela en cualquier momento. El cargo aparecerá en tu factura como {{domainUrl}}',
          email:
            'Te <bold>enviaremos un recordatorio por email</bold> antes de que termine tu período de prueba. ' +
            'Cancela en cualquier momento.',
        },
        pay: {
          trial: 'Por tu <bold>prueba de 7 días</bold>',
          price: 'Solamente',
          tax: 'Impuesto al valor agregado',
          total: 'Total',
        },
        resources: 'Pagos garantizados y seguros',
      },
    },
    'natal-chart': {
      progressBar: 'Tome las riendas de su vida',
      billingScreen: {
        description:
          'Al continuar, aceptas que se te cobre automáticamente {{price}} cada mes hasta que lo canceles en la configuración. Más información sobre la política de cancelación y reembolso en ',
        trialDescription:
          'Usted se está inscribiendo en <bold>7 días de suscripción</bold> al servicio NEBULA. Al continuar acepta que si no cancela antes del final de los <bold>7 días de prueba por {{trialPrice}}</bold>, se le cobrará automáticamente {{price}} cada mes hasta que cancele en la configuración. Más información sobre la política de cancelación y reembolso en',
        terms: 'Condiciones de suscripción.',
      },
    },
    agreement: {
      text: 'Al seleccionar la opción anterior usted acepta la',
      policy: 'Política de Privacidad',
      separator: 'y ',
      terms: 'Términos de uso.',
      textEnd: '',
    },
    emailAgreement: {
      text: 'Al continuar, acepto la',
      policy: 'Política de Privacidad',
      separator: 'y',
      terms: 'las Términos de uso',
      textEnd: 'de Nebula.',
    },
    paymentFailed: {
      title: 'Pago fallido',
      text: 'Tu transacción ha fallado por algún error técnico. Inténtalo de nuevo.',
      button: 'Intentar de nuevo',
    },
  },
};
